

<div class="items-summary-wrapper">

	<div class="items-summary-close"><div class="_inner" (mousedown)="cancel()"><mat-icon>keyboard_arrow_down</mat-icon></div></div>
	<div class="items-summary-content" [style.max-height]="maxHeight">
		@switch (workMode()) {
			<!-- ============================== START BASKET MODE ============================== -->
			@case ('basket') {
				@if ($storage.alcoholQuestion) {
					<div class="alert alert-info">{{$storage.alcoholQuestion}}</div>
				}
				@for (offer of $storage.basket; track offer; let last = $last) {
					<div class="basket-row" [class.last]="last">
						<div class="_header">
							@if (!data.canEditItems && offer.quantity > 1) {
								<div class="_counter text-highlight">{{ offer.quantity }}*</div>
							}
							<div class="_title">
								{{offer.name}}
							</div>
							@if (data.canEditItems) {
								<div class="_actions">
									@if (offer._enableEdit) {
										<button type="button" (mousedown)="editOffer(offer)" [disabled]="offer.isLoyaltyOffer">
											<mat-icon svgIcon="edit"></mat-icon>
										</button>
									}
									<button type="button" (mousedown)="deleteOffer(offer, false)" [class._inactive]="offer.quantity == 1">
										<!--<mat-icon [svgIcon]="offer.quantity == 1 ? 'trash' : 'minus'"></mat-icon>-->
										<mat-icon svgIcon="minus_circle"></mat-icon>
									</button>
									<div class="_counter text-highlight">
										{{offer.quantity}}
									</div>
									<button type="button" (mousedown)="duplicateOffer(offer)" [disabled]="offer.isLoyaltyOffer">
										<mat-icon svgIcon="plus_circle"></mat-icon>
									</button>
								</div>
							} @else {
								<div class="_price text-highlight">
									{{offer.quantity * offer.total | lcurrency}}
								</div>
							}
						</div>
						<div class="_summary">

							@if (offer._item && offer._item.summary) {
								<div class="_summary-row"><div>{{ offer._item.summary.text }}</div></div>
							}

							@if (offer.selectionSummary?.length) {
								@for (group of offer.selectionSummary | filterBy:{_visible:true}; track group.id) {
									<div class="_summary-row">
										<b>{{ group.name }}:</b>
										@for (item of group.items; track $index) {
											<div>
												<div>
													@if (item.count > 1) {
														<span>{{ item.count }}*</span>
													}
													{{ item.name || 'missing' }}
													@if (item._item.total > 0) {
														<span class="inline m-near-xs">+{{ item._item.total | lcurrency }}</span>
													}
												</div>
												@if (item.$wasEdit && item._item.summary) {
													<small class="block mb-1">{{ item._item.summary.text }}</small>
												}
											</div>
										}
									</div>
								}
							}
							@if (offer.offerRemrks) {
								<div class="_summary-row">
									<i>*{{ offer.offerRemrks }}</i>
								</div>
							}
						</div>
						@if (data.canEditItems) {
							<div class="_price text-highlight">
								{{offer.quantity * offer.total | lcurrency}}
							</div>
						}
					</div>
				}
			}
			<!-- ============================== START UPSELL MODE ============================== -->
			@case ('upsell') {
			<div class="offers-menu-cat-ai" [@listAnimation]="aiMessages().length" style="min-height: 190px; max-width: 480px">
				<div class="animated animate__flipInY">
					<lottie-anim class="mb-4" #aiLoadingAnim
								 [options]="{animation: 'aiLoading2', autoplay: true, loop: true }"
								 [height]="150"></lottie-anim>
				</div>
				<menu-offers-container>
					@for (member of aiMessages(); track member._id) {
						@switch (member.type) {
							@case ('offer') {
								<div class="menu-offer"
									 [id]="'cat_' + member._id"
									 (mousedown)="aiOfferClick(member,$event)"
									 [ngClass]="{'_active':$storage.order.offerCounters[member.viewItem.offer], '_disabled': member.viewItem.stockDisabled, 'animated fadeInUp fast': member._new}">
									<div class="menu-offer-body">
										<div class="_body">
											<div class="menu-offer-title">
												<mat-icon svgIcon="circle-plus-duotone"></mat-icon>
												<span>{{ member.data.itemNameDisplay || member.viewItem.name }}</span>
											</div>
											@if (member.description_display != 'hide') {
												<div class="menu-offer-description">{{ member.data.itemDescriptionDispaly || member.viewItem.description }}
												</div>
											}
											<div class="menu-offer-price">
												@if (member.viewItem.price > 0) {
													<div class="_price text-xs pb-1 font-weight-bold" >{{ member.viewItem.price | lcurrency }}</div>
												} @else {
													<div class="_price"></div>
												}
												<app-offer-attributes [offer]="member.viewItem"></app-offer-attributes>
											</div>
										</div>
										<!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
										<div class="_image" [ngStyle]="member.viewItem.catStyle || member.viewItem.cardStyle"
											 [class.stock-disabled]="member.viewItem.stockDisabled">
											<img [appImageSrc]="member.viewItem.imageURL" [model]="member" loading="lazy"/>
											<app-offer-marketing [offer]="member.viewItem" [$storage]="$storage"></app-offer-marketing>
										</div>
									</div>
								</div>
							}
							@case ('intro') {
								<div class="alert alert-default-alt _intro" [class.text-center]="member.data.center">
									{{member.data.intro}}
								</div>
							}
							@case ('recommendationReason') {
								<div class="alert alert-default-alt _recommendation">
									{{member.data.recommendationReason}}
								</div>
							}
						}
					}
					@if (aiLoading() && aiMessages().length > 0) {
						<div class="pt-2 pb-3">
							<div class="chat-spinner-message dark">
								<div class="dot"></div>
								<div class="dot"></div>
								<div class="dot"></div>
							</div>
						</div>
					}

				</menu-offers-container>
			</div>
			}
		}
	</div>

	<div id="items-summary-bottom">
		<div>
			@if ($storage.hasSummaryExtras) {
				<app-tabit-order-info [options]="{isInSummary: true}" class="basket-row-container"></app-tabit-order-info>
			}
		</div>

		<div class="items-summary-bottom">
			<button mat-raised-button color="accent" class="lg main-continue-btn" type="button"
					(mousedown)="continue()">
				<div class="_inner">
					<span>{{ "checkout" | translate }}</span>
					<b>{{ ($storage.order.grandTotal) | lcurrency }}</b>
					<div class="_cont rotate-rtl">
						<mat-icon svgIcon="arrow_next"></mat-icon>
					</div>
				</div>
			</button>
			@if (!data.canEditItems) {
				<div class="mt-3 text-center">
					<button mat-button extended color="accent" type="button" (mousedown)="backToMenu()">
						<mat-icon>{{ appService.backIcon }}</mat-icon>
						{{ "TO.back-to-menu" | translate }}
					</button>
				</div>
			}
		</div>
	</div>
</div>

